import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=6eeabea8&scoped=true"
import script from "./Permission.vue?vue&type=script&lang=js"
export * from "./Permission.vue?vue&type=script&lang=js"
import style0 from "./Permission.vue?vue&type=style&index=0&id=6eeabea8&prod&lang=sass&scoped=true"
import style1 from "./Permission.vue?vue&type=style&index=1&id=6eeabea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eeabea8",
  null
  
)

export default component.exports